var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapLegendPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 12",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 10.427a26.634 26.634 0 0 1-1.229-1.698c-.497-.75-.98-1.575-1.336-2.384C1.198 5.523 1 4.789 1 4.2 1 2.413 2.414 1 4.125 1S7.25 2.413 7.25 4.2c0 .589-.198 1.323-.56 2.145-.356.809-.839 1.634-1.336 2.384a26.613 26.613 0 0 1-1.229 1.698Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapLegendPin);
export default __webpack_public_path__ + "static/media/icon_map_legend_pin.dc96290fc572e31d8087220fbced09f7.svg";
export { ForwardRef as ReactComponent };